<template>
    <div
        class="columns is-gapless is-multiline mcq-quiz-show"
        style="margin-left: 48px;position: relative"
        ref="mcq-quiz-show"
    >
        <span v-if="mcq.allow_reading_options === true " class="speaker-icon icon" @click="speakMCQ()"
            ><img src="@/assets/images/speaker.svg" alt=""
        /></span>
        <div
            style="position: relative"
            class="column is-12 mb-2 is-flex"
            v-for="row_no in Math.ceil(
            mcq.options.length / optionButtonsEachRow
            )"
            :key="`row_option_${row_no}`"
        >
            <focus-button
            v-for="(option, option_index) in currentRowOptions(
                mcq.options,
                row_no
            )"
            :key="`QUESTION_OPTION_${option_index}`"
            @clicked="optionClicked(option_index, row_no, $event)"
            :text="option.is_hide_label ? '' : option.name"
            :layers="option.layers"
            :tables="option.tables"
            :layer="option.layer"
            :is_clicked="
                fetchCurrentAnswer.options.includes(
                (row_no - 1) * optionButtonsEachRow + option_index
                )
            "
            :display_type="option.option_type ? option.option_type : 'D'"
            :custom_width="option.custom_width"
            :styles="option.styles"
            :custom_layout="option.custom_layout"
            :clock="option.clock"
            :protractor="option.protractor"
            :bar_chart="option.bar_chart"
            :line_chart="option.line_chart"
            :thermometer="option.thermometer"
            :number_line="option.number_line"
            :shapes="option.shapes"
            ></focus-button>
        </div>
    </div>

</template>

<script>
import FocusButton from "@/components/FocusButton";
import { mapGetters, mapActions} from "vuex";

export default {
    name: "show-mcq",
    props: {
      mcq: {
        type: Object,
      },
    },
    components: {
        FocusButton
    },
    data() {
      return {

      };
    },
    methods: {
        ...mapActions([
            "updateCurrentAnswer",
        ]),
        async speakMCQ(){
            if(this.mcq?.allow_reading_options){
                const nodes = this.$refs['mcq-quiz-show'].querySelectorAll(".button-3d, .simple-2d")
                const mcq_options = this.mcq.options.map(o => o.name)
                for(let i in mcq_options){
                const oldColor = nodes[i].style.backgroundColor
                nodes[i].style.backgroundColor = "#21ff11"
                await this.$common.readQuestionLoud(mcq_options[i])
                nodes[i].style.backgroundColor = oldColor
                }
            }
        },
        currentRowOptions(options, row_no) {
            return options.slice(
                (row_no - 1) * this.optionButtonsEachRow,
                row_no * this.optionButtonsEachRow
            );
        },
        optionClicked(option_index, row_index, clicked_state) {
            let response_index =
                (row_index - 1) * this.optionButtonsEachRow + option_index;
            //Add option index to current answer

            if (clicked_state) {
                //If type is single answer mcq then remove all responses first
                if (this.mcq.type == "S") {
                this.updateCurrentAnswer({
                    key: "options",
                    value: [],
                });
                }

                this.updateCurrentAnswer({
                key: "options",
                value: [...this.fetchCurrentAnswer.options, response_index],
                });
            } else {
                this.updateCurrentAnswer({
                key: "options",
                value: this.fetchCurrentAnswer.options.filter(
                    (answer) => answer != response_index
                ),
                });
            }
        },
    },
    computed: {
        ...mapGetters([
            "fetchCurrentQuestionIndex",
            "fetchCurrentAnswer",
        ]),
        optionButtonsEachRow() {
        let no = 5;
        if (
            this.mcq.option_buttons_each_row
        ) {
            no = this.mcq.option_buttons_each_row;
        }
        return no;
        },
    }
}  
</script>
<style scoped>
.speaker-icon{
    position: absolute;
    margin-left: -48px;
  }
</style>